import React, { useState, useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import Modal from "react-bootstrap/Modal";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../../assest/bachatwaliticket.png";
import Login from "../Login/Login";
import EnquiryForm from "../EnquiryForm/EnquiryForm";
import icon1 from "../../assest/footericon.svg";
import icon2 from "../../assest/footericon2.svg";

const NAV_LINKS = [
  { label: "Flight", tab: "flight" },
  { label: "Hotel", tab: "hotel" },
  { label: "Bus", tab: "bus" },
];

const Header = () => {
  const [showEnquiry, setShowEnquiry] = useState(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeOffcanvas = () => setShowOffcanvas(false);

  const isActive = (path) =>
    path === "/" ? location.pathname === "/" : location.pathname.startsWith(path);

  const handleBookingClick = () => {
    const token = localStorage.getItem("token");
    navigate(!token ? "/login/customer" : "/dashboard?tab=bookings");
  };

  const handleEnquiryClick = () => {
    setShowEnquiry(true);
    closeOffcanvas();
  };

  const handleTabNavigation = (tabType) => {
    if (location.pathname === "/") {
      document.querySelector(".slider-container")?.scrollIntoView({ behavior: "smooth" });
      window.dispatchEvent(new CustomEvent("setActiveTab", { detail: { tabType } }));
    } else {
      navigate(`/?tab=${tabType}`);
    }
    closeOffcanvas();
  };

  return (
    <>

      {/* Desktop header — hidden on the home page specifically (the hero there already carries
          the logo/search tabs, so a second nav bar on top would duplicate it). The mobile top
          bar and bottom nav below are NOT duplicative and always render, on every page. */}
      <header
        className={`${location.pathname === "/" ? "hidden" : "hidden lg:block"} sticky top-0 z-40 bg-white/95 backdrop-blur border-b transition-shadow ${
          scrolled ? "border-ink-100 shadow-sm" : "border-ink-100/70"
        }`}
      >
        <div className="max-w-[1280px] mx-auto px-6 h-[76px] flex items-center gap-8">
          <a href="/" className="flex items-center gap-2.5 shrink-0">
            <img src={logo} alt="Bachatwali Ticket" className="h-10 w-auto rounded-lg" />
            <span className="text-[19px] font-extrabold tracking-tight text-ink-900">
              Bachatwali Ticket
            </span>
          </a>

          <nav className="flex items-center gap-1 flex-1">
            <a
              href="/"
              className={`px-4 py-2 rounded-lg text-[15px] font-semibold transition ${
                isActive("/")
                  ? "text-brand-700 bg-brand-50"
                  : "text-ink-700 hover:bg-ink-50 hover:text-ink-900"
              }`}
            >
              Home
            </a>
            {NAV_LINKS.map((l) => (
              <button
                key={l.tab}
                onClick={() => handleTabNavigation(l.tab)}
                className="px-4 py-2 rounded-lg text-[15px] font-semibold text-ink-700 hover:bg-ink-50 hover:text-ink-900 transition"
              >
                {l.label}
              </button>
            ))}
            <a
              href="/taxi"
              className={`px-4 py-2 rounded-lg text-[15px] font-semibold transition ${
                isActive("/taxi")
                  ? "text-brand-700 bg-brand-50"
                  : "text-ink-700 hover:bg-ink-50 hover:text-ink-900"
              }`}
            >
              Taxi
            </a>
            <a
              href="/marketplace"
              className={`px-4 py-2 rounded-lg text-[15px] font-semibold transition ${
                isActive("/marketplace")
                  ? "text-brand-700 bg-brand-50"
                  : "text-ink-700 hover:bg-ink-50 hover:text-ink-900"
              }`}
            >
              Packages
            </a>
            <a
              href="/Blogs"
              className={`px-4 py-2 rounded-lg text-[15px] font-semibold transition ${
                isActive("/Blogs")
                  ? "text-brand-700 bg-brand-50"
                  : "text-ink-700 hover:bg-ink-50 hover:text-ink-900"
              }`}
            >
              Blog
            </a>
            <button
              onClick={() => setShowEnquiry(true)}
              className="px-4 py-2 rounded-lg text-[15px] font-semibold text-ink-700 hover:bg-ink-50 hover:text-ink-900 transition"
            >
              Enquiry
            </button>
          </nav>

          <div className="flex items-center gap-3 shrink-0">
            <div className="hidden xl:flex items-center gap-2">
              <a
                href="https://play.google.com/store/apps/details?id=com.om.rasutrip&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
                className="opacity-80 hover:opacity-100 transition"
              >
                <img src={icon2} alt="Get it on Google Play" className="h-9 w-auto" />
              </a>
              <a
                href="https://apps.apple.com/app/rasutrip-bus-flight-hotel/id6753738292"
                target="_blank"
                rel="noopener noreferrer"
                className="opacity-80 hover:opacity-100 transition"
              >
                <img src={icon1} alt="Download on App Store" className="h-9 w-auto" />
              </a>
            </div>
            <div className="h-6 w-px bg-ink-200 hidden xl:block" />
            <Login />
          </div>
        </div>
      </header>

      {/* Mobile header */}
      <header className="lg:hidden sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-ink-100">
        <div className="flex items-center justify-between px-4 h-16">
          <a href="/" className="flex items-center gap-2">
            <img src={logo} alt="Bachatwali Ticket" className="h-8 w-auto rounded-md" />
            <span className="text-[14px] font-extrabold tracking-tight text-ink-900">
              Bachatwali Ticket
            </span>
          </a>
          <div className="flex items-center gap-3">
            <Login />
            <button
              onClick={() => setShowOffcanvas(true)}
              aria-label="Open menu"
              className="h-9 w-9 flex items-center justify-center rounded-lg border border-ink-200 text-ink-700"
            >
              <i className="fas fa-bars text-sm" />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile bottom nav */}
      <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-ink-100 shadow-[0_-4px_16px_rgba(20,22,29,0.06)]">
        <div className="grid grid-cols-5">
          {[
            { icon: "fa-house", label: "Home", onClick: () => navigate("/"), active: isActive("/") },
            { icon: "fa-book", label: "Booking", onClick: handleBookingClick },
            { icon: "fa-bed", label: "Hotels", onClick: () => handleTabNavigation("hotel") },
            { icon: "fa-bus", label: "Bus", onClick: () => handleTabNavigation("bus") },
            { icon: "fa-bars", label: "More", onClick: () => setShowOffcanvas(true) },
          ].map((item) => (
            <button
              key={item.label}
              onClick={item.onClick}
              className={`flex flex-col items-center justify-center gap-1 py-2.5 active:text-brand-600 ${
                item.active ? "text-brand-600" : "text-ink-500"
              }`}
            >
              <i className={`fa-solid ${item.icon} text-[17px]`} />
              <span className="text-[10.5px] font-semibold">{item.label}</span>
            </button>
          ))}
        </div>
      </nav>

      {/* Mobile drawer menu */}
      <Navbar.Offcanvas
        id="offcanvasNavbar"
        placement="end"
        show={showOffcanvas}
        onHide={closeOffcanvas}
      >
        <Offcanvas.Header closeButton className="border-b border-ink-100">
          <Offcanvas.Title>
            <img src={logo} alt="Bachatwali Ticket" className="h-8 w-auto" />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="px-4">
          <p className="text-xs font-bold tracking-wider text-ink-400 uppercase mb-2 mt-2">Travel Services</p>
          <div className="flex flex-col mb-6">
            {NAV_LINKS.map((l) => (
              <button
                key={l.tab}
                onClick={() => handleTabNavigation(l.tab)}
                className="text-left px-3 py-3 rounded-xl text-[15px] font-semibold text-ink-800 hover:bg-brand-50 hover:text-brand-700 transition"
              >
                {l.label}
              </button>
            ))}
          </div>

          <p className="text-xs font-bold tracking-wider text-ink-400 uppercase mb-2">Other</p>
          <div className="flex flex-col mb-6">
            <a
              href="/taxi"
              onClick={closeOffcanvas}
              className="px-3 py-3 rounded-xl text-[15px] font-semibold text-ink-800 hover:bg-brand-50 hover:text-brand-700 transition"
            >
              Book a Taxi
            </a>
            <a
              href="/marketplace"
              onClick={closeOffcanvas}
              className="px-3 py-3 rounded-xl text-[15px] font-semibold text-ink-800 hover:bg-brand-50 hover:text-brand-700 transition"
            >
              Holiday Packages
            </a>
            <a
              href="/Blogs"
              onClick={closeOffcanvas}
              className="px-3 py-3 rounded-xl text-[15px] font-semibold text-ink-800 hover:bg-brand-50 hover:text-brand-700 transition"
            >
              Blog
            </a>
            <button
              onClick={handleEnquiryClick}
              className="text-left px-3 py-3 rounded-xl text-[15px] font-semibold text-ink-800 hover:bg-brand-50 hover:text-brand-700 transition"
            >
              Enquiry
            </button>
          </div>

          <div className="text-center border-t border-ink-100 pt-6">
            <p className="text-xs font-bold tracking-wider text-ink-400 uppercase mb-3">Get Our App</p>
            <div className="flex flex-col items-center gap-3">
              <a
                href="https://play.google.com/store/apps/details?id=com.om.rasutrip&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeOffcanvas}
              >
                <img src={icon2} alt="Get it on Google Play" className="w-40" />
              </a>
              <a
                href="https://apps.apple.com/app/rasutrip-bus-flight-hotel/id6753738292"
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeOffcanvas}
              >
                <img src={icon1} alt="Download on App Store" className="w-40" />
              </a>
            </div>
          </div>
        </Offcanvas.Body>
      </Navbar.Offcanvas>

      {/* Enquiry modal */}
      <Modal show={showEnquiry} onHide={() => setShowEnquiry(false)} size="lg" centered>
        <Modal.Body className="p-0">
          <EnquiryForm />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Header;
